import { render, staticRenderFns } from "./clear-all-trash.html?vue&type=template&id=0958f050&scoped=true&"
import script from "./clear-all-trash.js?vue&type=script&lang=js&"
export * from "./clear-all-trash.js?vue&type=script&lang=js&"
import style0 from "./clear-all-trash.scss?vue&type=style&index=0&id=0958f050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958f050",
  null
  
)

export default component.exports